// extracted by mini-css-extract-plugin
export default {"base":"Badge_base__5nbat"};